import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Table, Button, Popconfirm, Tooltip } from "antd";
import { DeleteTwoTone, InfoCircleOutlined, PlusOutlined } from '@ant-design/icons';
import BaseSelect from '@/components/Elements/BaseSelect';
import { fetchActiveCustomers } from '@/redux/actions/customerActions';
import { getRelationshipTypeActive } from '@/redux/actions/relationshipTypeActions';
import CustomerSelect from './CustomerSelect';

const CustomerRelationshipForm = (props) => {

    const [items, setItems] = useState([{
        key: 0,
        related_id: "",
        relationship_type: "",
        relationship_type_inverse: "",
    }]);

    const relatedIds = items.map(item => item.related_id);

    useEffect(() => {
        props.getRelationshipTypeActive();
        props.fetchActiveCustomers({ is_selected: relatedIds });
    }, [items]);

    const { activeList, getItems, currentData } = props;

    const [count, setCount] = useState(0);

    useEffect(() => {
        if (currentData && currentData.length > 0) {
            const initialItems = currentData.map((item, index) => ({
                key: index + 1,
                related_id: item.related_id,
                relationship_type: item.relationship_type,
                relationship_type_inverse: item.relationship_type_inverse,
            }));
            setItems(initialItems);
            setCount(initialItems.length);
        } else {
            setItems([{
                key: 0,
                related_id: "",
                relationship_type: "",
                relationship_type_inverse: "",
            }]);
            setCount(0);
        }
    }, [currentData]);

    useEffect(() => {
        getItems(items);
    }, [items]);

    const onAdd = () => {
        const newItem = {
            key: count + 1,
            related_id: "",
            relationship_type: "",
            relationship_type_inverse: "",
        };
        setItems([...items, newItem]);
        setCount(count + 1);
    };

    const onDelete = (key) => {
        const updatedItems = items.filter(item => item.key !== key);
        setItems(updatedItems);
    };

    const onChangeItem = (name, value, itemKey) => {
        const updatedItems = items.map(item =>
            item.key === itemKey ? { ...item, [name]: value } : item
        );
        setItems(updatedItems);
    };

    var columns = [
        {
            title: "Họ và tên",
            dataIndex: "full_name",
            render: (text, record) => {
                return (
                    <CustomerSelect
                        value={record.related_id || undefined}
                        onChange={(id) => onChangeItem('related_id', id, record.key)}
                    />
                )
            }
        },
        {
            title: (
                <>
                    Khách hàng mới là
                    <Tooltip title="Mối quan hệ của khách hàng đang tạo đối với người này">
                        <InfoCircleOutlined style={{ marginLeft: 6 }} />
                    </Tooltip>
                </>
            ),
            dataIndex: "relationship_type",
            width: "180px",
            render: (text, record) => {
                return (
                    <BaseSelect
                        options={activeList || []}
                        optionValue="id"
                        optionLabel="name"
                        placeholder="Chọn"
                        defaultValue={text ? text : null}
                        style={{ width: '100%' }}
                        showSearch={true}
                        onChange={(e) => onChangeItem('relationship_type', e, record.key)}
                    />
                )
            }
        },
        {
            title: (
                <>
                    Người này là
                    <Tooltip title="Mối quan hệ của người này đối với khách hàng đang tạo">
                        <InfoCircleOutlined style={{ marginLeft: 6 }} />
                    </Tooltip>
                </>
            ),
            dataIndex: "relationship_type_inverse",
            width: "180px",
            render: (text, record) => {
                return (
                    <BaseSelect
                        options={activeList || []}
                        optionValue="id"
                        optionLabel="name"
                        placeholder="Chọn"
                        defaultValue={text ? text : null}
                        style={{ width: '100%' }}
                        showSearch={true}
                        onChange={(e) => onChangeItem('relationship_type_inverse', e, record.key)}
                    />
                )
            }
        },
        {
            title: "#",
            align: "center",
            width: "50px",
            render: (text, record) => {
                return (
                    <Popconfirm
                        title="Xóa dòng này?"
                        placement='topRight'
                        onConfirm={() => onDelete(record.key)}
                    >
                        <DeleteTwoTone twoToneColor="#fe0000" />
                    </Popconfirm>
                )
            }
        }
    ];

    return (
        <>
            <div className='chingo-normal-title'>Thông tin người liên quan</div>
            <Table
                className='mt-2 mb-2'
                size='small'
                rowKey='key'
                tableLayout="auto"
                columns={columns}
                dataSource={items}
                locale={{ emptyText: "Chưa có dữ liệu" }}
                pagination={false}
                scroll={{
                    x: 'max-content'
                }}
            />
            <Button type="default" size='small' onClick={() => onAdd()} icon={<PlusOutlined />}>Thêm người liên quan</Button>
        </>
    )
}

function mapStateToProps(state) {
    return {
        activeList: state.relationshipTypeReducer.activeList
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getRelationshipTypeActive: (filter) => dispatch(getRelationshipTypeActive(filter)),
        fetchActiveCustomers: (filter) => dispatch(fetchActiveCustomers(filter))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerRelationshipForm);